import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  getAddresses: (url: string, mask: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        mask,
      },
    }),
};
